import { FunctionComponent, memo, useEffect, useState } from 'react'
import PathAmountSelect from 'components/Smava/PathAmountSelect'

import { Debtor } from 'containers/PersonalForm/PersonalForm.interface'
import { Typography, Link } from '@mui/material'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'
import { useClientDetails } from 'stores/utils/hooks/useClientDetails'
import { useStores } from 'stores/utils/hooks/useStores'
import {
  CreditChangeOption,
  RDI_TYPE
} from 'interfaces/ApolloResponse.interface'
import { useData } from 'stores/utils/hooks/useData'
import { roundUpToNextThousand } from 'utils/loanSelector'
import RCEEditFieldDebtor from 'components/AbTestComponents/CAT3598/RCEEditFieldDebtor'

interface Props {
  debtor?: Debtor
}

interface LabelProps {
  declarationOfConsentAdvertising?: string
}

export const PageText = {
  editPage: 'Weiter',
  editPage_additional: 'Direkt zu den Angeboten'
}

const Label: FunctionComponent<LabelProps> = memo(
  ({ declarationOfConsentAdvertising = '' }) => (
    <Typography variant="body2">
      Ich möchte über Angebote von smava informiert werden. Ich kann meine{' '}
      <Link
        href={declarationOfConsentAdvertising}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        onClick={() =>
          trackInAmplitude(AmplitudeEvent.OnNewsletterConsentLinkClicked)
        }
      >
        Einwilligung
      </Link>{' '}
      zukünftig jederzeit widerrufen.
    </Typography>
  )
)

Label.displayName = 'Label'

const RCEEdit = () => {
  const [isPatched, setIsPatched] = useState(false)
  const {
    traversal: {
      handlePathFormFieldChange,
      removePathsFromPayload,
      overrideDataInTraversal
    }
  } = useStores()
  const {
    data: {
      common: { amount }
    }
  } = useData()

  useEffect(() => {
    handlePathFormFieldChange(
      'common.amountAdaption',
      CreditChangeOption.nothing,
      false
    )

    const { rounded } = roundUpToNextThousand(amount)

    if (rounded !== amount) {
      handlePathFormFieldChange('common.amount', rounded, false)
    }
    handlePathFormFieldChange('debtors.primary.activeLoans', [], false)
    handlePathFormFieldChange('debtors.primary.numberOfActiveLoans', 0, false)
    const data = removePathsFromPayload(['common.manuallyAdaptedAmount'])
    overrideDataInTraversal(data)
    handlePathFormFieldChange('common.rdi.type', RDI_TYPE.none, true)
    handlePathFormFieldChange('common.rdi.hasAcceptedConsultation', true, true)
    setIsPatched(true)
  }, [])

  // this is added so that the validations only occur after TPL data has been reset
  if (!isPatched) {
    return
  }

  return (
    <>
      <PathAmountSelect path={'common.amount'} outerLabel smallTextField />
      <RCEEditFieldDebtor outerLabel smallTextField handleOnlyPrimaryDebtor />
    </>
  )
}

export default memo(RCEEdit)
